import { PaypalPaymentResult } from "../types/orderTypes";
import api from "../utils/api";
import { logoutUser } from "./authActions";
import { clearCart } from "./cartActions";
import {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_PAY_REQUEST,
  ORDER_PAY_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_USERS_LIST_SUCCESS,
  ORDER_USERS_LIST_REQUEST,
  ORDER_USERS_LIST_FAIL,
  ORDER_LIST_SUCCESS,
  ORDER_LIST_REQUEST,
  ORDER_LIST_FAIL,
} from "./constants/order";

export const createOrder = (order: any, promoCode?: string) => async (
  dispatch: any,
  getState: any
) => {
  try {
    dispatch({
      type: ORDER_CREATE_REQUEST,
    });

    const { data } = await api.post(`/orders`,{...order, promoCode});

    dispatch({
      type: ORDER_CREATE_SUCCESS,
      payload: data,
    });
    // clear cart after the successful order
    dispatch(clearCart());
  } catch (error: any) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: ORDER_CREATE_FAIL,
      payload: message,
    });
  }
};

export const getOrderDetails = (id: string) => async (dispatch: any) => {
  try {
    dispatch({
      type: ORDER_DETAILS_REQUEST,
    });

    const { data } = await api.get(`/orders/${id}`);

    dispatch({
      type: ORDER_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logoutUser());
    }
    dispatch({
      type: ORDER_DETAILS_FAIL,
      payload: message,
    });
  }
};

export const payOrder = (
  orderId: string,
  paymenResult: PaypalPaymentResult
) => async (dispatch: any) => {
  try {
    dispatch({
      type: ORDER_PAY_REQUEST,
    });

    const { data } = await api.put(`/orders/${orderId}/pay`, paymenResult);

    dispatch({
      type: ORDER_PAY_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logoutUser());
    }
    dispatch({
      type: ORDER_PAY_FAIL,
      payload: message,
    });
  }
};

export const updateOrderStatus = (
  orderId: string,
  payload: {
    status: string;
    reason?: string;
    provider?: string;
    update_time?: string;
  }
) => async (dispatch: any) => {
  try {
    await api.put(`/orders/${orderId}/status`, payload);
    const { data } = await api.get(`/orders/${orderId}`);
    dispatch({
      type: ORDER_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logoutUser());
    }
    dispatch({
      type: ORDER_DETAILS_FAIL,
      payload: message,
    });
  }
};

type HistoryStatusFilter = "all" | "paid" | "cancelled";

type ListUsersOrdersParams = {
  from?: string;
  to?: string;
  status?: HistoryStatusFilter;
  page?: number;
  limit?: number;
};

export const listUsersOrders = (
  params: ListUsersOrdersParams = {},
  options: { append?: boolean } = {}
) => async (dispatch: any) => {
  try {
    dispatch({
      type: ORDER_USERS_LIST_REQUEST,
      append: Boolean(options.append),
    });

    const searchParams = new URLSearchParams();
    if (params.from) {
      searchParams.set("from", params.from);
    }
    if (params.to) {
      searchParams.set("to", params.to);
    }
    if (params.status && params.status !== "all") {
      searchParams.set("status", params.status);
    }
    if (typeof params.page === "number" && params.page > 0) {
      searchParams.set("page", String(params.page));
    }
    if (typeof params.limit === "number" && params.limit > 0) {
      searchParams.set("limit", String(params.limit));
    }

    const query = searchParams.toString();
    const { data } = await api.get(`/orders/myorders${query ? `?${query}` : ""}`);

    dispatch({
      type: ORDER_USERS_LIST_SUCCESS,
      payload: data,
      append: Boolean(options.append),
    });
  } catch (error: any) {
    dispatch({
      type: ORDER_USERS_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
      append: Boolean(options.append),
    });
  }
};

export const listUsersOrdersByCreator = (startDate?: string, endDate?: string) => async (dispatch: any) => {
  try {
    dispatch({
      type: ORDER_USERS_LIST_REQUEST,
    });

    const { data } = await api.get(`/creators/orders`, {
      params: {
        startDate,
        endDate
      }
    });

    dispatch({
      type: ORDER_USERS_LIST_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    dispatch({
      type: ORDER_USERS_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listAllOrders = (page: number, limit: number) => async (dispatch: any) => {
  try {
    dispatch({
      type: ORDER_LIST_REQUEST,
    });

    const { data } = await api.get(`/orders`, {
      params: {
        page,
        limit
      }
    });

    dispatch({
      type: ORDER_LIST_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    dispatch({
      type: ORDER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
